var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.buttonWrapper,on:{"click":_vm.handleClick}},[_c('div',{class:_vm.$style.buttonInner},[_vm._t("default",[_vm._v("I am Button")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }